// @ts-check

const getDialogs = () => {
    const dialog = document.querySelectorAll("dialog");

    if (dialog.length === 0) return null;

    return Array.from(dialog);
};
/**
 * Handles the dialog functionality.
 * @param {HTMLDialogElement} dialog
 * @returns {void}
 */
const handleDialog = (dialog) => {
    const dialogTrigger = document.getElementById(dialog.getAttribute("data-triggerId") ?? "");

    if (!dialogTrigger) return;

    //   Close dialog with close button
    const dialogClose = dialog.querySelector(".dialog-close");
    if (dialogClose instanceof HTMLButtonElement) {
        dialogClose.focus();

        dialogClose.addEventListener("click", (e) => {
            e.preventDefault();
            dialog.close();
            document.body.classList.remove("overflow-hidden");
        });
    }

    dialogTrigger.addEventListener("click", (e) => {
        dialog.showModal();
        document.body.classList.add("overflow-hidden");
    });

    dialog.addEventListener("click", (e) => {
        // Get dialog "limits" to close the dialog when clicking outside of it.
        // This ignores the possible padding inside the dialog.
        // And does not close it when clicking the padding in the dialog.
        const rect = dialog.getBoundingClientRect();
        const isInDialog = (rect.top <= e.clientY && e.clientY <= rect.top + rect.height &&
            rect.left <= e.clientX && e.clientX <= rect.left + rect.width);

        if (!isInDialog) {
            dialog.close();
            document.body.classList.remove("overflow-hidden");
        }
    });
};

const init = () => {
    const dialogs = getDialogs();
    if (!dialogs) return;

    dialogs.forEach((el) => handleDialog(el));
};

document.addEventListener("DOMContentLoaded", () => {
    init();
});
